export const SIZES = {
    PREVIEW_WINDOW_OFFSET: 50,
    PREVIEW_MIN_HEIGHT: 100,
    PREVIEW_MAX_HEIGHT: 600,
    PREVIEW_MAX_WIDTH: 700
};
